import { render, staticRenderFns } from "./UsedGifts.vue?vue&type=template&id=37ac520d&"
import script from "./UsedGifts.vue?vue&type=script&lang=js&"
export * from "./UsedGifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports